(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ewn-home"] && !Shopify.designMode) return;
  try {
    
(() => {
const PRODUCTS=window.EWN_PRODUCTS,ui=window.EWN_UI;
if(!PRODUCTS)return;
const escapeHTML=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const grid=document.querySelector('#product-grid');
function render(filter='All'){
const list=PRODUCTS.slice(0,4).filter(p=>filter==='All'||p.topic===filter);
grid.innerHTML=list.map(p=>`<article class="product-card"><button class="cover-button" data-product="${p.handle}" aria-label="${escapeHTML(p.short)}"><span class="cover-index" aria-hidden="true">0${PRODUCTS.indexOf(p)+1}</span><img src="${p.image}" alt="${escapeHTML(p.short)}" width="1024" height="1536" loading="lazy"></button><div class="product-category">${escapeHTML(p.topic)}</div><h3 class="product-title"><a class="title-button" href="${escapeHTML(p.url)}">${escapeHTML(p.short)}</a></h3><div class="product-meta">${ui.format} · ${p.pages} ${ui.pages}</div><div class="product-bottom"><span class="price">${p.price}</span><button class="view-guide" data-product="${p.handle}">${ui.explore} ↗</button></div></article>`).join('');
document.querySelector('#filter-status').textContent=list.map(p=>p.short).join(', ');
document.querySelectorAll('.filter').forEach(b=>{const active=b.dataset.filter===filter;b.classList.toggle('active',active);b.setAttribute('aria-pressed',active)});
}
const toggle=document.querySelector('#topics-toggle'),topics=document.querySelector('#topics'),menuToggle=document.querySelector('#menu-toggle'),menu=document.querySelector('#mobile-menu');
function closeMenus(){topics.hidden=true;toggle.setAttribute('aria-expanded','false');menu.hidden=true;menuToggle.setAttribute('aria-expanded','false')}
toggle.addEventListener('click',()=>{topics.hidden=!topics.hidden;toggle.setAttribute('aria-expanded',!topics.hidden)});
menuToggle.addEventListener('click',()=>{menu.hidden=!menu.hidden;menuToggle.setAttribute('aria-expanded',!menu.hidden)});
const dialog=document.querySelector('#guide-dialog');let previousFocus;
document.addEventListener('click',e=>{
const f=e.target.closest('[data-filter]');if(f){render(f.dataset.filter);closeMenus();if(!f.classList.contains('filter'))document.querySelector('#guides').scrollIntoView({behavior:'smooth'})}
const button=e.target.closest('[data-product]');if(button){const p=PRODUCTS.find(x=>x.handle===button.dataset.product);previousFocus=document.activeElement;document.querySelector('#guide-content').innerHTML=`<div class="detail-grid"><div><img class="detail-cover" src="${p.image}" alt="${escapeHTML(p.short)}"></div><div><div class="eyebrow">${escapeHTML(p.topic)} · ${ui.format}</div><h2 class="detail-title" id="detail-title">${escapeHTML(p.short)}</h2><p class="detail-price">${p.price} <small>· ${p.pages} ${ui.pages}</small></p><form class="detail-buy" method="post" action="${ui.cartAdd}"><input type="hidden" name="id" value="${p.variant||''}"><input type="hidden" name="quantity" value="1"><input type="hidden" name="return_to" value="/cart"><button class="primary-button" type="submit" ${p.available?'':'disabled'}>${p.available?ui.add:ui.soon}</button></form><p class="detail-access">${ui.downloadNote}</p><p><a class="detail-product-link" href="${escapeHTML(p.url)}">${ui.details} ↗</a></p><div class="detail-body">${p.description_html}</div><button class="detail-back">${ui.back}</button></div></div>`;dialog.setAttribute('aria-labelledby','detail-title');dialog.showModal();document.body.classList.add('modal-open');dialog.querySelector('.close-dialog').focus()}
if(e.target.closest('.close-dialog,.detail-back'))dialog.close();
if(!e.target.closest('.nav-dropdown')){topics.hidden=true;toggle.setAttribute('aria-expanded','false')}
if(e.target.closest('#mobile-menu a'))closeMenus();
});
dialog.addEventListener('close',()=>{document.body.classList.remove('modal-open');previousFocus?.focus()});
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenus()});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
